import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import { useStyles } from './styles.js';

class LeaderboardHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event: props.event,
    };
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { className, classes, history, smallBusiness } = this.props;

    return (
      <Grid className={classes.queTabSec}>
        <Grid className={classes.tabContainer}>
          <ul
            className={classes.tabHead}
            style={{ borderColor: this.props.buttonTextColor }}
          >
            <li
              style={{
                background: this.props.buttonTextColor,
                borderColor: this.props.buttonTextColor,
                color: '#fff',
              }}
              className={classes.activeTab}
              key={`tabHeader${0}`}
              data-key={`${0}`}
            >
              <span className={smallBusiness ? classes.sbTitle : ''}>{this.props.event_name}</span>
            </li>
          </ul>
        </Grid>
      </Grid>
    );
  }
}

LeaderboardHeader.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(LeaderboardHeader);
